import { Component,Inject } from '@angular/core';
import { Router } from '@angular/router';
import {
AuthenticationService,
AuthenticationServiceToken,
} from '../../services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  standalone: true,
})
export class LoginComponent {
  constructor(
    private router: Router,
    @Inject(AuthenticationServiceToken)
    private authService: AuthenticationService
  ) {
    // FIXME - should we do something more with nagivation errors?
    this.router.navigate(['correspondences']).catch(r => r);
  }

}
